// src/modules/app-views/collaborators/seed.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import appService from 'services/appService';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DEFAULT_SEEDS = {
  form: {
    entityPersonType: 'person', // 'manual' | 'person' | 'company'
    entityPersonDefault: 'person', // default selection when manual mode
    allowForeignCountries: false, // internationalization OFF
  },
  requiredFields: ['cpf', 'birthdate', 'phone', 'email', 'address'],
  departments: [],
  positions: [],
};

// *******************************************************************************
// MAIN FUNCTION
// *******************************************************************************
async function seedCollaboratorsParameters({ moduleId, storedParameters }) {
  if (!moduleId) return;

  const moduleParams = storedParameters?.modules?.[moduleId];

  // Skip seeding if the module already has any configuration data
  // This prevents race condition where seed might run before SSE delivers saved settings
  // Once the module has any saved preferences, we trust the backend as source of truth
  if (moduleParams && Object.keys(moduleParams).length > 0) {
    return [];
  }

  const results = [];

  // Seed form settings if module has no data yet
  const formResult = await seedForm({
    moduleId,
    defaultData: DEFAULT_SEEDS.form,
  });
  if (formResult) results.push(formResult);

  // Seed required fields if module has no data yet
  const requiredFieldsResult = await seedRequiredFields({
    moduleId,
    defaultData: DEFAULT_SEEDS.requiredFields,
  });
  if (requiredFieldsResult) results.push(requiredFieldsResult);

  return results;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default seedCollaboratorsParameters;

// *******************************************************************************
// HELPERS
// *******************************************************************************
async function seedForm({ moduleId, defaultData }) {
  try {
    await appService.updateModulePreferences({
      category: 'form',
      moduleId,
      data: defaultData,
    });

    return { category: 'form', seeded: true, data: defaultData };
  } catch (error) {
    console.error('[seedCollaboratorsParameters] Error seeding form:', error);
    return { category: 'form', seeded: false, error };
  }
}

async function seedRequiredFields({ moduleId, defaultData }) {
  try {
    await appService.updateModulePreferences({
      category: 'requiredFields',
      moduleId,
      data: defaultData,
    });

    return { category: 'requiredFields', seeded: true, data: defaultData };
  } catch (error) {
    console.error('[seedCollaboratorsParameters] Error seeding requiredFields:', error);
    return { category: 'requiredFields', seeded: false, error };
  }
}
